// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"140":"13692031","320":"7c8f2533","532":"7c8f2533"}[chunkId] + ".chunk.css";
};